import React, { useState, useEffect } from 'react';
import Dropdown from './widgets/dropdown';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';

import { useTheme } from '../theme/ThemeContext';


const ColorBox = ({ scatterplot, setScatterColorCategory, setSelectedIcon, hasUserSamples }) => {
    const { theme } = useTheme();
    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite

    const colorBoxStyle = {
        margin: '20px',
        padding: '20px',
        color: '#dadada',
        width: '200px',
        fontFamily: 'Arial',
        backgroundColor: theme.colors.overlay,
        borderRadius: '10px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        transition: 'all 0.3s ease-in-out',
        overflow: 'display',
    };
    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };


    const handleColorSelection = (coloring) => {
        console.log('coloring:', coloring);
        const colorConvertDict = {
            'Biome GOLD': 'source_biome',
            'Clustered Biomes': 'source_biome_clustered',
            'Biome annotation': 'environment_material',
            'Sequencer': 'instrument_model',
            'Geographic location': 'geographic_location',
            'Study': 'study_id',
            'Shannon Index': 'shannon_index_e',
            'Simpson index': 'simpson_index',
            'Richnes': 'richnes',
            'Richness': 'richnes',
            'Chao1': 'chao1',
            'Temperature': 'temperature',
            // 'Confidence': 'confidence',
            'Unknownness': 'unknownness_score',
        }
        setScatterColorCategory(colorConvertDict[coloring]);
    }




    return (
        <div style={colorBoxStyle}>
            <img
                src={CloseIcon}
                alt="Close"
                style={closeIconStyle}
                onClick={() => setSelectedIcon(null)}
            />
            <h2>Color by</h2>
            <Dropdown
                items={[
                    'Biome GOLD',
                    'Clustered Biomes',
                    // 'Biome annotation',
                    "Sequencer",
                    'Study',
                    "Shannon Index",
                    'Simpson index',
                    'Richness',
                    'Chao1',
                    'Temperature',
                    // 'Unknownness',
                    // ...(hasUserSamples ? ['Confidence'] : []) // only show if user samples exist
                ]}
                onSelect={handleColorSelection}
                placeholder="Select Coloring"
            />
        </div>
    );
}

export default ColorBox;